import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Container } from '@mui/system';
import { useTranslation } from 'react-i18next';
import FaqImage from '../../../assets/faq.png'
import GuidBUySellImage from '../../../assets/guid-buy-sell.png'
import GuidAuthImage from '../../../assets/guid_auth.png'
import WeblogImge from '../../../assets/weblog.png'
import './LearnMore.css'
import { Box } from '@mui/material';
import LearnMorePicture from '../../../assets/learn_more_pars_img.png'

const LearnMore = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ bgcolor: 'background.default' , py:4 }}>
            <Container maxWidth='xl'>
                <Stack direction={'row'} mb={2} spacing={4} justifyContent={'center'} alignItems={'center'}>
                    <div style={{ background: 'linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)', width: '130px', height: '1px' }}></div>
                    <Typography variant='h4' sx={{ textAlign: 'center', mb: 2, color: 'text.primary' }}>{t('learn_more_with_rabsana')}</Typography>
                    <div style={{ background: 'linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)', transform: 'rotate(-180deg)', width: '130px', height: '1px' }}></div>
                </Stack>
                <Grid container spacing={4} mt={4}>
                    <Grid item xs={12} md={5}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='Learn_More_card'>
                                    <CardContent>
                                        <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                            <Box className='img_cards_Learn_More'>
                                                <img src={GuidBUySellImage} width='auto' />
                                            </Box>
                                        </Grid>
                                        <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                            {t('guid_buy_sell')}
                                        </Typography>

                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='Learn_More_card'>
                                    <CardContent>
                                        <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                            <Box className='img_cards_Learn_More'>
                                                <img src={GuidAuthImage} width='auto' />
                                            </Box>
                                        </Grid>
                                        <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                            {t('guid_auth')}
                                        </Typography>

                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='Learn_More_card'>
                                    <CardContent>
                                        <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                            <Box className='img_cards_Learn_More'>
                                                <img src={WeblogImge} width='auto' />
                                            </Box>
                                        </Grid>
                                        <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                            {t('weblog')}
                                        </Typography>

                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ borderRadius: '10px', pt: 3, bgcolor: 'background.cardsHome' }} className='Learn_More_card'>
                                    <CardContent>
                                        <Grid container justifyContent="center" sx={{ mb: 2 }} className='parent_img_cards_services'>
                                            <Box className='img_cards_Learn_More'>
                                                <img src={FaqImage} width='auto' />
                                            </Box>
                                        </Grid>
                                        <Typography gutterBottom variant='h5' sx={{ textAlign: 'center', mb: 1 }}>
                                            {t('faqs')}
                                        </Typography>

                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={7} sx={{ display: 'flex', justifyContent: {xs:'center' , md:'end'}, alignItems: 'center' }}>
                        <Box>
                            <img src={LearnMorePicture} alt='picture learn more' width='100%' />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default LearnMore